import { WxTpl } from '../../rule/models/ScheduleMsg';

export interface MassSendWxImage {
  media: string;
}

export interface MassSendWxNews {
  mediaId: string;
  allowReprint: boolean;
  onlyFansCanComment: boolean;
  openComment: boolean;
  isToAll: boolean;
  newsId: number;
  snapshot: string;
}

export interface MassSendWxText {
  text: string;
}

export interface MassSendWxCard {
  cardId?: string;
  cardText?: string;
}

export default interface MassSendMsg {
  WxImage?: MassSendWxImage;
  WxNews?: MassSendWxNews;
  WxText?: MassSendWxText;
  WxTpl?: WxTpl;
  WxCard?: MassSendWxCard;
}

export enum MassSendMsgType {
  Text = 1,
  News = 2,
  Image = 3,
  Card = 4,
  Tpl = 5,
  WxSub = 6
}
